"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _freeSolidSvgIcons = require("@fortawesome/free-solid-svg-icons");
var _KnockRequestListItem = require("./KnockRequestListItem.styled");
var _AcceptAs = _interopRequireDefault(require("./AcceptAs"));
var _utils = require("../../../utils");
var _resources = require("../../../resources");
var _ = require("../..");
var ScreenShareKnockRequestListItem = function ScreenShareKnockRequestListItem(_ref) {
  var zIndex = _ref.zIndex,
    name = _ref.name,
    onApprove = _ref.onApprove,
    onReject = _ref.onReject,
    animation = _ref.animation,
    sources = _ref.sources;
  _react["default"].useEffect(function () {
    var audio = new Audio(knockSound);
    audio.play();
  }, []);
  var knockSound = _resources.resources.knockSound;
  var title = 'New screenshare request';
  var icon = _freeSolidSvgIcons.faDoorOpen;
  var message = 'wants to screenshare';
  var hasDropDownButton = sources && sources.length > 0;
  var isLongMessage = "".concat((0, _utils.truncate)(name), " ").concat(message).length > 35;
  var targetElement = 'message-screenshare';
  return _react["default"].createElement(_KnockRequestListItem.StyledKnockRequestItemWrapper, (0, _extends2["default"])({
    role: "alert",
    "aria-live": "polite",
    zIndex: zIndex
  }, animation, {
    hideAVIcons: true,
    isLongMessage: isLongMessage,
    hasDropDownButton: hasDropDownButton
  }), _react["default"].createElement(_KnockRequestListItem.StyledRow, null, _react["default"].createElement(_KnockRequestListItem.StyledCol, {
    md: 3
  }, _react["default"].createElement(_KnockRequestListItem.StyledDoorIcon, {
    icon: icon,
    "aria-hidden": true
  })), _react["default"].createElement(_KnockRequestListItem.StyledCol, {
    md: 9
  }, _react["default"].createElement(_KnockRequestListItem.StyledKnockRequestItemTitle, null, title), _react["default"].createElement(_KnockRequestListItem.StyledKnockRequestItemBody, null, _react["default"].createElement(_KnockRequestListItem.StyledGuestName, {
    id: targetElement,
    className: "dd-privacy-mask"
  }, (0, _utils.truncate)(name), " ", message), _react["default"].createElement(_.ToolTip, {
    className: "dd-privacy-mask",
    targetElement: targetElement,
    message: name
  })))), _react["default"].createElement(_KnockRequestListItem.StyledRow, null, _react["default"].createElement(_KnockRequestListItem.StyledCol, {
    md: 12
  }, _react["default"].createElement(_KnockRequestListItem.StyledKnockRequestItemFooter, {
    addTopMargin: isLongMessage
  }, hasDropDownButton ? _react["default"].createElement(_AcceptAs["default"], {
    name: name,
    sources: sources,
    onApprove: onApprove
  }) : _react["default"].createElement(_KnockRequestListItem.StyledAcceptKnockButton, {
    "data-testid": "knock-approve-button-".concat(name),
    onClick: function onClick() {
      onApprove();
    },
    "aria-label": "Approve ".concat(name, "'s request")
  }, _react["default"].createElement(_KnockRequestListItem.StyledFontAwesomeIcon, {
    icon: _freeSolidSvgIcons.faCheck,
    "aria-hidden": true
  }), "Approve"), _react["default"].createElement(_KnockRequestListItem.StyledRejectKnockButton, {
    "data-testid": "knock-reject-button-".concat(name),
    onClick: onReject,
    "aria-label": "Reject ".concat(name, "'s request")
  }, _react["default"].createElement(_KnockRequestListItem.StyledFontAwesomeIcon, {
    icon: _freeSolidSvgIcons.faTimesCircle,
    "aria-hidden": true
  }), "Reject")))));
};
ScreenShareKnockRequestListItem.propTypes = {
  name: _propTypes["default"].string.isRequired,
  onApprove: _propTypes["default"].func.isRequired,
  onReject: _propTypes["default"].func.isRequired,
  zIndex: _propTypes["default"].number.isRequired,
  animation: _propTypes["default"].shape({
    initial: _propTypes["default"].object,
    animate: _propTypes["default"].object,
    exit: _propTypes["default"].object,
    transition: _propTypes["default"].object
  }),
  sources: _propTypes["default"].array
};
var _default = exports["default"] = ScreenShareKnockRequestListItem;